import { render, staticRenderFns } from "./DnWidgetBase.vue?vue&type=template&id=7fd73a8c&scoped=true&"
import script from "./DnWidgetBase.vue?vue&type=script&lang=js&"
export * from "./DnWidgetBase.vue?vue&type=script&lang=js&"
import style0 from "./DnWidgetBase.vue?vue&type=style&index=0&id=7fd73a8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd73a8c",
  null
  
)

export default component.exports